<div class="alert" [class]="alertClass" [innerHTML]="errorContent">
</div>
